import React from "react";
import { Table as SharedTable } from "../../../../shared/components/Molecules/Table/Table";
import "./Table.css";
import { TableProps } from "../../../../shared/components/Molecules/Table/Table";

export const Table = (props: TableProps) => <SharedTable {...props} />;
